export default __webpack_public_path__ + "static/media/boys_girls_club_logo.33d27c2f.svg";